import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSetAtom } from 'jotai';
import { Button, Paper, Stack, Box } from '@mui/material';
import PasswordRoundedIcon from '@mui/icons-material/PasswordRounded';
import { openSnackbarAdviseAtom } from '../../../Atoms';
import useAuthAPI from '../../../api/auth';
import '../../../Styles/login.scss';
import ContentError from '../../../Components/Error/ContentError';

const SetupFIDO2Page = function SetupFIDO2Page() {
  const intl = useIntl();
  const AuthAPI = useAuthAPI();
  const setOpenSnackbarAdvise = useSetAtom(openSnackbarAdviseAtom);
  const [passkeyAlreadyCreated, setPasskeyAlreadyCreated] = useState(true);

  useEffect(() => {
    AuthAPI.fido2Enabled()
      .then(({ data }) => {
        setPasskeyAlreadyCreated(data);
      })
      .catch(() => {
        setOpenSnackbarAdvise({
          message: intl.messages.ERROR,
          severity: 'error',
        });
      });
  }, []);

  const handleSetupFIDO2 = () => {
    AuthAPI.fido2register(
      () => {
        setPasskeyAlreadyCreated(true);
        setOpenSnackbarAdvise({
          message: intl.messages.SUCCESS_SETUP_PASSKEY,
          severity: 'success',
        });
      },
      () => {
        setOpenSnackbarAdvise({
          message: intl.messages.ERROR_SETUP_PASSKEY,
          severity: 'error',
        });
      }
    );
  };

  const handleDisableFIDO2 = () => {
    AuthAPI.fido2removecredentials(
      () => {
        setPasskeyAlreadyCreated(false);
        setOpenSnackbarAdvise({
          message: intl.messages.PASSKEY_REMOVED,
          severity: 'success',
        });
      },
      () => {
        setOpenSnackbarAdvise({
          message: intl.messages.ERROR_SETUP_PASSKEY,
          severity: 'error',
        });
      }
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        padding: '2vw',
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
        }}
      >
        {!passkeyAlreadyCreated && (
          <Box
            sx={{
              display: 'flex',
            }}
          >
            <Stack
              sx={{
                alignItems: 'center',
              }}
            >
              <Button
                id="enable-2fa-btn"
                color="primary"
                onClick={handleSetupFIDO2}
                sx={{ width: '160px' }}
              >
                {intl.messages.PASSKEY_SETUP}
              </Button>
            </Stack>
          </Box>
        )}
        {passkeyAlreadyCreated && (
          <>
            <ContentError
              icon={
                <PasswordRoundedIcon
                  sx={{ color: '#acacac', fontSize: '64px' }}
                />
              }
              text={intl.messages.PASSKEY_ALREADY_SETUP}
              message={intl.messages.CLICK_ON_BTN_TO_DISABLE}
              sizes={{
                title: '36px',
                message: '24px',
              }}
            />
            <Button
              id="disable-2fa-btn"
              color="primary"
              onClick={handleDisableFIDO2}
              sx={{ width: '160px' }}
            >
              {intl.messages.DISABLE}
            </Button>
          </>
        )}
      </Paper>
    </div>
  );
};

export default SetupFIDO2Page;
